import {local} from 'wix-storage';
import wixLocation from 'wix-location';

 
$w.onReady(function () {

});

 
export function searchButtonHeader_click(event) {
    
    let edp = $w("#searchBox1").value;

    local.setItem("searchedp", edp);

    $w("#searchBox1").value = ''

    wixLocation.to(`/search-products`);
    //wixLocation.to(wixLocation.url);
}


export function searchBox1_change(event) {
    let edp = $w("#searchBox1").value;
    local.setItem("searchedp", edp);
    $w("#searchBox1").value = ''
    wixLocation.to(`/search-products`);
}